import { Controller } from '@hotwired/stimulus';
import { WebViewEvent, checkIfWebView } from '@infakt/webview-toolkit';

export default class extends Controller {
  sendEvent(event) {
    if (checkIfWebView()) {
      event.preventDefault();

      return new WebViewEvent({
        event: 'OpenBrowser',
        params: {
          url: event.target.href,
        },
      }).dispatch();
    }
  }

  sendDownloadFileEvent(event) {
    if (checkIfWebView()) {
      event.preventDefault();

      return new WebViewEvent({
        event: 'DownloadFile',
        params: {
          url: event.target.href,
        },
      }).dispatch();
    }
  }

  sendDownloadFileNoPreviewEvent(event) {
    if (checkIfWebView()) {
      event.preventDefault();

      return new WebViewEvent({
        event: 'DownloadFile',
        params: {
          url: event.target.href,
          forceNoPreview: true,
        },
      }).dispatch();
    }
  }
}
